import React, { useEffect } from 'react';
import { PageHero } from '../components/page/PageHero';
import { WhyLawyerLed } from '../components/page/WhyLawyerLed';
import { FinalCTA } from '../components/home/FinalCTA';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { MapPin } from 'lucide-react';
const VALUES = [{
  title: 'Lawyer-led',
  body: 'A qualified solicitor is involved in your matter, so legal questions are answered properly rather than passed on.'
}, {
  title: 'Boutique by choice',
  body: 'A smaller practice means you deal with the team handling your file, not a queue.'
}, {
  title: 'Carlton based, Victoria wide',
  body: 'Based on Elgin Street in Carlton and acting on Victorian property matters across the state.'
}];
export function About() {
  useEffect(() => {
    document.title = 'About L.A Property Law & Conveyancing | Carlton Melbourne';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-590">
      <PageHero eyebrow="about the firm" title="A boutique property practice in Carlton." intro="L.A Property Law combines conveyancing process management with access to legal advice when a matter needs more than paperwork." imageSrc="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80" imageAlt="Warm, contemporary professional office interior" primaryLabel="Get a free quote" primaryAction="quote" data-id="element-591" />

      <section className="px-5 md:px-6 py-20 md:py-28 bg-surface" data-id="element-592">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 items-start" data-id="element-593">
          <div className="lg:col-span-7" data-id="element-594">
            <p className="font-script text-2xl text-accent mb-1" data-id="element-595">how we work</p>
            <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-596">
              Conveyancing is routine, until it isn't.
            </h2>
            <p className="mt-5 text-lg text-muted-ink leading-relaxed" data-id="element-597">
              A transaction can change quickly when a title issue, an unsuitable
              special condition, a disclosure problem or an ownership-structure
              question appears. Having a property lawyer involved means those
              moments are handled with proper advice, not left to chance.
            </p>
            <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-598">
              The result is one coordinated process, from the first review of
              the contract through to settlement, with clear communication along
              the way.
            </p>
            <div className="mt-8" data-id="element-599">
              <Link to="/team" data-id="element-600">
                <Button variant="outline" size="lg" data-id="element-601">
                  Meet the legal team
                </Button>
              </Link>
            </div>
          </div>
          <div className="lg:col-span-5 grid gap-4" data-id="element-602">
            {VALUES.map(v => <div key={v.title} className="rounded-2xl bg-background border border-border p-6 shadow-card" data-id="element-603">
                <h3 className="font-serif text-xl text-ink" data-id="element-604">{v.title}</h3>
                <p className="mt-2 text-muted-ink leading-relaxed" data-id="element-605">{v.body}</p>
              </div>)}
            <a href="https://maps.google.com/?q=202+Elgin+Street+Carlton+VIC+3053" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-blue font-semibold hover:underline" data-id="element-606">
              <MapPin className="w-4 h-4" data-id="element-607" />
              202 Elgin Street, Carlton VIC 3053
            </a>
          </div>
        </div>
      </section>

      <WhyLawyerLed data-id="element-608" />
      <FinalCTA data-id="element-609" />
    </main>;
}